export function formatSeconds(
  milliseconds: number,
  includeMilliseconds = true
): string {
  const seconds = Math.floor(milliseconds / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)

  const remainingHours = hours % 60
  const remainingMinutes = minutes % 60
  const remainingSeconds = seconds % 60
  const remainingMilliseconds = milliseconds % 1000

  return `${remainingHours.toString().padStart(2, '0')}:${remainingMinutes
    .toString()
    .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}${
    includeMilliseconds
      ? `.${remainingMilliseconds.toString().padStart(3, '0')}`
      : ''
  }`
}
